import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SwipeToBuy, TripProductType, XSellBanner } from '../wizumen-models';
import { SwipeToBuyService } from 'projects/common/services/swipe-to-buy.service';
import { UpaTarget, UpaTrackingData } from 'projects/common/services/upa.service';
import { UtilsService } from 'projects/common/services/utils.service';
import { AbstractComponent } from '../../abstract.component';

@Component({
  selector: 'swipe-to-buy-modal',
  template: `
    <div class="swipeToBuyModalContent {{isHotelModal ? 'hotel-modal' : ''}}">
      <div class="swipeToBuyCard">
        <div class="swipeToBuyCard">
          <h4 class="eva-3-h4" [ngClass]="{'-eva-3-mt-md': isHotelModal}">{{assistance.title}}</h4>
          <ul [ngClass]="{'-eva-3-mt-lg': !isHotelModal, '-eva-3-mt-md': isHotelModal}" class="item-list">
            <li class="flex" 
              [ngClass]="{'-eva-3-mt-xsm': !isHotelModal, '-eva-3-mb-md': isHotelModal}"
              *ngFor="let descriptionItem of assistance.description_items">
              <i class="eva-3-icon-checkmark green-color -eva-3-icon-sm -eva-3-mr-xsm"></i>
              <span [ngClass]="{assistanceItemDescriptionText: !isHotelModal, 'eva-3-body-2 -eva-3-ml-sm': isHotelModal}">{{descriptionItem}}</span>
            </li>
          </ul>
        </div>
        <div *ngIf="!isHotelModal" class="eva-3-pricebox-cluster -eva-3-mt-lg">
          <div class="pricebox-top-container">
            <div class="pricebox-value-container">
              <div class="pricebox-value">
                <ng-container *ngIf="isLoyaltySwitchActive; then redemption; else notRedemption">
                </ng-container>
                <ng-template #redemption>
                  <div class="pricebox-strikethrough-text">
                    {{assistance.price.currency}}
                    {{assistance.price.regular_amount ? assistance.price.regular_amount : assistance.price.amount}}
                  </div>
                  <span class="pricebox-currency">{{assistance.loyalty.redemption.summary.currency}}</span>
                  <span class="pricebox-big-text">{{assistance.loyalty.redemption.summary.to_pay}}</span>
                  <div class="pricebox-small-text redemption-points">{{assistance.loyalty.redemption.description}}</div>
                </ng-template>
                <ng-template #notRedemption>
                  <div *ngIf="assistance.price.regular_amount" class="pricebox-strikethrough-text">
                    {{assistance.price.currency}} {{assistance.price.regular_amount}}
                  </div>
                  <span class="pricebox-currency">{{assistance.price.currency}}</span>
                  <span class="pricebox-big-text">{{assistance.price.amount}}</span>
                </ng-template>
              </div>
              <div class="pricebox-small-text -description">{{assistance.price_message}}</div>
            </div>
            <div class="pricebox-action">
              <span class="eva-3-link remember-later -eva-3-mb-xxlg"
                 (click)="closeModal($event, 'remember-later-button')">{{assistance.remember_later_message}}</span>
              <div class="swipeToBuyButtonContainer">
                <button type="button" class="eva-3-btn -md -primary -eva-3-mt-lg" name="buy"
                        (click)="buy()">
                  <em class="btn-text">{{assistance.buy_button_message}}</em>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="assistance.loyalty?.redemption">
            <div class="loyalty-separator"></div>
            <!-- Todavia no esta soportado el switch para desktop hay que esperar que hagan el desarrollo ya que no soporta dos intancias de switch en la misma pagina -->
            <loyalty-switch
              (clickedLoyaltySwitch)="onClickedLoyaltySwitch($event)"
              [upaTrackingData]="upaTrackingData"
              [containerUniqueId]="'assistance-offer-modal-loyalty-switch'"
              [disableContainerStyles]="true" [flow]="flow">
            </loyalty-switch>
          </div>
        </div>

        <div *ngIf="isHotelModal" class="coupon-section">

          <p class="eva-3-body-2 -eva-3-mb-lg">{{assistance.description}}</p>

          <incentive-xsell-coupon
            [xSellBanner]="hotelCoupon"
            [moduleId]="this.moduleId"
            [moduleIndex]="this.moduleIndex"
            [uniqueId]="this.uniqueId"
            [useImg]="false"
            [fullWidth]="true"
            [showApplyButton]="false">
          </incentive-xsell-coupon>

          <div class="swipeToBuyModalCloseButtonContainer -eva-3-mt-md">
            <eva-button 
              (clickEvent)="closeModal($event, 'see-hotels-button', false)"
              [options]="{type: '-primary', full_width: true ,link: assistance.button_url, link_text: assistance.buy_button_message}"
              [moduleId]="this.uniqueId"
              [upaData]="{label: 'HOTEL_MODAL'}"></eva-button>
          </div>
      </div>
    </div>
  `,
  styleUrls: ['./swipe-to-buy-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SwipeToBuyModal extends AbstractComponent implements OnInit {
  static MODULE_ID = 'AssistanceModalModule';

  @Input() assistance: SwipeToBuy;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() override flow: string;

  isLoyaltySwitchActive: boolean;
  upaTrackingData: UpaTrackingData;
  isHotelModal: boolean = false;
  hotelCoupon: XSellBanner;
  
  constructor(
    injector: Injector, 
    protected swipeToBuyService: SwipeToBuyService, 
    private utilsService: UtilsService) {
      super(injector);
  }

  ngOnInit(): void {
    const cookieValue = this.utilsService.getCookieValue("redemption_switch");
    this.isLoyaltySwitchActive = cookieValue === "redemption";

    this.upaTrackingData = {
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.SWIPE_TO_BUY_MODAL
    };

    if (this.assistance.product === TripProductType.HOTEL) {
      this.isHotelModal = true;
      this.hotelCoupon = {
        coupon_code: this.assistance.coupon_code,
        coupon_copied_text: this.assistance.coupon_copied_text,
        type: TripProductType.XSELL_MALBEC,
        links: [],
        offers: []
      };
    }
  }

  buy() {
    this.swipeToBuyService.buy()
  }

  closeModal(event: any, label: string = "close-button", preventDefault: boolean = true) {
    if (preventDefault) {
      event.preventDefault();
    }
    this.swipeToBuyService.closeModal(label, label === "remember-later-button");
  }

  onClickedLoyaltySwitch(newSwitchState: boolean) {
    this.isLoyaltySwitchActive = newSwitchState;
  }

  getModuleId() {
    return this.moduleId || SwipeToBuyModal.MODULE_ID;
  }
}
